<template>
    <!-- mt: desconta a barra de acessibilidade, que fica no cabeçalho fixo (HeaderTop), quando ela está ligada -->
    <header class="bg-admin-primary text-white" :class="{ 'mt-[var(--altura-barra-acessibilidade)]': barraAcessibilidadeAtiva }">

        <div class="container mx-auto  flex justify-between items-center  pt-5 pb-3  pl-2">
            <div v-show="isMobile" style="margin-top: -24px; margin-bottom: -14px;">
                <a href="/" class="font-bold underline hover:text-admin-primary transition ">
                    <img v-if="logo.logo_herder_top" :src="logo.logo_herder_sub" alt="Prefeitura Municipal de Parnaíba"
                        class="h-16 w-full" @error="(e) => { e.target.style.display = 'none' }" />
                    <div v-else class="flex items-center gap-2 text-white text-sm font-medium">
                        <span class="text-xs bg-gray-200 px-2 py-1 rounded">Sem logo</span>
                    </div>
                </a>
            </div>
            <a v-show="!isMobile" href="/ " class="font-bold underline hover:text-admin-primary transition "
                style="margin-top: -32px;">
                <img v-if="logo.logo_herder_top" :src="logo.logo_herder_sub" alt="Prefeitura Municipal de Parnaíba"
                    class="h-34 sm:h-12 md:h-32" />
                <div v-else class="flex items-center gap-2 text-white text-sm font-medium">
                    <span class="text-xs bg-gray-200 px-2 py-1 rounded">Sem logo</span>
                </div>
            </a>
            <nav class="hidden lg:flex flex-wrap justify-center gap-x-2 gap-y-2" style="margin-top: -12px;">
                <div v-for="item in menuItems" :key="item.path" @click="router.visit(item.path)"
                    @keydown.enter="router.visit(item.path)" @keydown.space="router.visit(item.path)" tabindex="0"
                    class="px-4 py-2 rounded-lg font-medium text-white cursor-pointer
                           border border-transparent
                           transition-colors duration-200 ease-in-out
                           hover:bg-blue-100 hover:text-admin-primary hover:border-blue-300"
                    :class="{ 'font-semibold underline': currentRoute === item.path }">
                    {{ item.label }}
                </div>
            </nav>
            <button style="border: none; margin-top: -7px;" v-show="isMobile && !drawerOpen" @click="drawerOpen = true"
                class="btn btn-ghost btn-square md:hidden" aria-label="Abrir menu">
                <svg class="h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 17 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M1 1h15M1 7h15M1 13h15"></path>
                </svg>
            </button>
        </div>
        <div :class="isMobile ? 'bg-yellow-warning px-1' : 'bg-yellow-warning py-2 px-1'">
            <div class="container mx-auto px-2 sm:px-4 py-0">
                <!-- Celular: acessibilidade e data centralizadas, uma embaixo da outra; computador: lado a lado -->
                <div class="flex flex-col sm:flex-row justify-between items-center gap-1.5 sm:gap-3 py-1.5 sm:py-0 text-center sm:text-left">
                    <ControlesTamanhoTexto class="justify-center" />
                    <div class="w-full sm:w-auto flex justify-center sm:justify-end">

                        <SimpleWeather :isMobile="isMobile" :weather="weather" />
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide-right">
            <div v-if="drawerOpen" class="fixed inset-0 z-50 flex">
                <div class="flex-1 bg-black/40 backdrop-blur-sm" @click="drawerOpen = false"></div>
                <div class="w-4/5 sm:w-64 bg-white text-blue-900 h-full overflow-y-auto shadow-xl">
                    <div class="p-4 border-b border-gray-100 flex justify-between items-center">
                        <h3 class="font-bold text-lg">Menu</h3>
                        <button @click="drawerOpen = false" class="btn btn-sm btn-ghost" aria-label="Fechar menu">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <nav class="py-2">
                        <div v-for="item in menuItems" :key="item.path" @click="navigateTo(item.path)"
                            @keydown.enter="navigateTo(item.path)" @keydown.space="navigateTo(item.path)" tabindex="0"
                            class="flex items-center px-4 py-3 text-gray-800 font-medium cursor-pointer
                                   border-l-4 border-transparent
                                   transition-colors
                                   hover:bg-blue-50 hover:text-admin-primary hover:border-blue-300">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2 text-blue-600" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5l7 7-7 7" />
                            </svg>
                            {{ item.label }}
                        </div>
                    </nav>
                    <div class="px-4 pt-4 pb-6 border-t border-gray-100">
                        <transition name="fade">
                            <ul v-if="showDropdownInDrawer && filteredOptions.length"
                                class="mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-32 overflow-y-auto">
                                <li v-for="option in filteredOptions" :key="option"
                                    class="px-3 py-2 text-sm text-gray-800 hover:bg-blue-50 cursor-pointer"
                                    @click="selectOption(option)">
                                    {{ option }}
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>
    </header>
</template>

<script setup>
import ControlesTamanhoTexto from '@/Components/Welcom/ControlesTamanhoTexto.vue'
import { barraAcessibilidadeVisivel } from '@/Utils/configuracaoSite'
import { Link } from '@inertiajs/vue3'
import {
    ref,
    computed,
    onMounted,
    onUnmounted,
    nextTick,
    watch
} from 'vue'
import { router, usePage } from '@inertiajs/vue3'
import {
    Menu,
    X,
    Search,
    ChevronRight
} from 'lucide-vue-next'
import WeatherWidget from '@/Components/Weather/WeatherWidget.vue'
import SimpleWeather from '@/Components/Weather/SimpleWeather.vue'

const { props } = usePage()
const logo = props.logo || {}
const page = usePage()
// Ligada/desligada em Configurações > Opções do site.
const barraAcessibilidadeAtiva = computed(() => barraAcessibilidadeVisivel(page.props.configuracaoSite))
const currentRoute = computed(() => page.url)
const weather = computed(() => page.props.weather ?? {})

const menuItems = [
    { label: 'Início', path: '/' },
    { label: 'Cidade', path: '/cidade' },
    { label: 'Equipe de Governo', path: '/equipe-governo' },
    { label: 'Notícias', path: '/noticias-geral' },
    { label: 'Calendário', path: '/calendario-eventos' },
]

const isMobile = ref(false)
const drawerOpen = ref(false)
const searchQuery = ref('')
const showDropdown = ref(false)
const showDropdownInDrawer = ref(false)
const debounceTimer = ref(null)

const filteredOptions = computed(() => {
    if (!searchQuery.value.trim()) return []
    const q = searchQuery.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return menuItems.map(i => i.label).filter(label =>
        label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(q)
    )
})

const handleBlur = () => {
    debounceTimer.value = setTimeout(() => {
        showDropdown.value = false
    }, 200)
}

const handleBlurDrawer = () => {
    debounceTimer.value = setTimeout(() => {
        showDropdownInDrawer.value = false
    }, 200)
}

const selectOption = (label) => {
    const item = menuItems.find(i => i.label === label)
    if (item) {
        navigateTo(item.path)
        searchQuery.value = ''
        showDropdown.value = false
        showDropdownInDrawer.value = false
        drawerOpen.value = false
    }
}

const navigateTo = (path) => {
    if (!path) return

    // ✅ Detecta URL externa e abre em nova aba
    if (path.startsWith('https')) {
        window.open(path, '_blank', 'noopener,noreferrer')
    } else {
        router.visit(path)
    }
    drawerOpen.value = false
}

const selectDrawerItem = (item) => {
    navigateTo(item.path)
}

const updateIsMobile = () => {
    isMobile.value = window.innerWidth < 1024
}

onMounted(() => {
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
})

onUnmounted(() => {
    window.removeEventListener('resize', updateIsMobile)
    if (debounceTimer.value) clearTimeout(debounceTimer.value)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-right-enter-from {
    transform: translateX(100%);
}

.slide-right-leave-to {
    transform: translateX(100%);
}
</style>
